import { Modal } from 'ant-design-vue'

export function caseLogin() {
    let isLogin=window.sessionStorage.getItem('isLogin')
    if(isLogin==0) {

        return true
    }else if(isLogin==1){
        Modal.confirm({
            title: '提示',
            content: '当前用户未登录，请先登录',
            onOk: () => {
                sessionStorage.removeItem('isLogin')
                sessionStorage.setItem('loginType', '')
                location.href = "https://www.jsghfw.com/yyczxt/jis/jumptologin.do?nowUrl=https://tyzy.jsghfw.cn/jss_zgh_12351_pc_web&appmark=jsgh12351";

            },
            onCancel() { }
        })
        return false
    }else{
        let user = sessionStorage.getItem('user')
        if (!user) {
        Modal.confirm({
            title: '提示',
            content: '当前用户未登录，请先登录',
            onOk: () => {
                sessionStorage.removeItem('isLogin')
                sessionStorage.setItem('loginType', '')
                location.href = "https://www.jsghfw.com/yyczxt/jis/jumptologin.do?nowUrl=https://tyzy.jsghfw.cn/jss_zgh_12351_pc_web&appmark=jsgh12351";

            },
            onCancel() { }
        })
        return false
    } else {
        return true
    }
    }

}
